import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.nl';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.en-US';

var datepicker = {

	settings: {
		date: {
			autoclose: true,
			forceParse: false,
			enableOnReadonly: false,
			format: 'dd-mm-yyyy'
		},
		month: {
			autoclose: true,
			forceParse: false,
			enableOnReadonly: false,
			format: 'mm-yyyy',
			viewMode: 'months',
			minViewMode: 'months'
		}
	},

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function() {

		datepicker.settings.date.language = datepicker.getLanguage();
		datepicker.settings.month.language = datepicker.getLanguage();

		(function($) {

			/** Init basis datepicker */
			$('.datepicker').datepicker(datepicker.settings.date);

			/** Init datepicker met alleen jaar en maand */
			$('.datepicker-months').datepicker(datepicker.settings.month);

			/** Blur datepicker input as kalender verborgen wordt */
			$('.datepicker, .datepicker-months').on('hide', function(event) {
				$(this).trigger('blur');
				let triggerEvent = new Event('blur');
				event.currentTarget?.dispatchEvent(triggerEvent);
			});

			/** Focus op juiste veld als kalender aangeklikt wordt */
			$('.input-group-text.fa-calendar').click(function() {
				$(this).closest('input').focus();
				$(this).closest('div').find('.datepicker, .datepicker-months').focus();
			});

			/** Focus op juiste veld als datepicker geopend wordt */
			$('.open-datepicker').click(function(e) {
				e.preventDefault();
				$(this).parent().parent().find('input').focus();
			});

		}(jQuery));

	},

	getLanguage() {
		if (typeof window.app.language !== 'undefined') {
			return window.app.language.replace('_', '-');
		} else {
			return 'nl-NL';
		}
	}

};

export default datepicker;
